import * as React from 'react';
import { globalStyles as GlobalStyles } from './theme/globalStyles';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from './theme/styled-components';
import { createRoot } from 'react-dom/client';
import { theme } from './theme/theme';
import Api from './api';
import App from './containers/App';
import SportnetApi from './sportnetApi';
import configureStore from './configureStore';

Api.setBaseUrl(String(process.env.REACT_APP_CONTROLLING_API_BASE_URL));
SportnetApi.setBaseUrl(String(process.env.REACT_APP_API_BASE_URL));

const store = configureStore();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
        <Router>
          <App />
        </Router>
      </>
    </ThemeProvider>
  </Provider>
);
